import config from 'src/config';
import { getRequest, postRequest, putRequest } from 'src/utils/RequestUtil';

export const userSearchAPI = function (data) {
    const url = `${config.baseUrl}user/get`;
    return postRequest({
        url,
        data,
    });
};
export const fetchUserDetailsAPI = function (data) {
    const url = `${config.baseUrl}user/Details`;
    return getRequest({
        url,
        data,
    });
};

export const fetchUserScopesAPI = ({
    userId,
    roleId
}) => {
    // const url = `${config.baseUrl}auth/getPermissions/${userId}/${roleId}`;
    const url = `https://server.acadedigital.com/api/v1/auth/getPermissions/${userId}/${roleId}`;
    return getRequest({
        url,
    });
};
export const userProfilePicAPI = function ({
    userId,
    data,
}) {
    const fd = new FormData();
    Object.keys(data).forEach((key) => {
        if (Array.isArray(data[key])) {
            const jsonString = JSON.stringify(data[key]);
            fd.append(key, jsonString);
        } else {
            fd.append(key, data[key]);
        }
    });
    const url = `${config.baseUrl}user/userProfilePicAPI/${userId}`;
    return putRequest({
        url,
        data: fd,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const userUploadAPI = function ({ data }) {
    const fd = new FormData();
    Object.keys(data).forEach((key) => {
        if (Array.isArray(data[key])) {
            const jsonString = JSON.stringify(data[key]);
            fd.append(key, jsonString);
        } else {
            fd.append(key, data[key]);
        }
    });
    const url = `${config.baseUrl}user/userBulkUploadAPI`;
    return postRequest({
        url,
        data: fd,
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const userCreateAPI = function (data) {
    const url = `${config.baseUrl}user/save`;
    return postRequest({
        url,
        data,
    });
};

export const userUpdateAPI = function ({
    userId,
    data,
}) {
    const url = `${config.baseUrl}user/update/${userId}`;
    return putRequest({
        url,
        data,
    });
};

export const getReportingManager = function (data) {
    const url = `${config.baseUrl}user/getReportingManager`;
    return postRequest({
        url,
        data,
    });
};

export const invitationResend = function (data) {
    const url = `${config.baseUrl}user/reSendInvitation`;
    return postRequest({
        url,
        data,
    });
};
export const getAssignedProjectFromAPI = function (userId) {
    const url = `${config.baseUrl}project/getAssignedProjects/${userId}`;
    return getRequest({
        url,
    });
};
export const getTaskByProjectFromAPI = function (projectId,userId) {
    const url = `${config.baseUrl}project/getTasksByProjectId/${projectId}/${userId}`;
    return getRequest({
        url,
    });
};
export const getModuleByTaskFromAPI = function (taskId) {
    const url = `${config.baseUrl}project/getModuleByTaskId/${taskId}`;
    return getRequest({
        url,
    });
};
export const getUserList = async (where = {}) => {
    const response = await postRequest({
      url: `${config.baseUrl}user/get`,
      data: { where }
    })
    return response
  }